
import Page from '../../components-ui/page';
import styles from './HomePage.module.css';
import TotalRevenueChart from '../../components-ui/dashboard/TotalRevenueChart';
import StatCards from '../../components-ui/dashboard/StatCardData.';
import StudentStatusChart from '../../components-ui/dashboard/StudentStatusChart';
import GraduationByLevel from '../../components-ui/dashboard/GraduationByLevel';
import GradeRankingChart from '../../components-ui/dashboard/GradeRankingChart';
import StudentsByLevel from '../../components-ui/dashboard/StudentsByLevel';

const HomePage = () => {
    return <div></div>
    return (
        <Page title='Trang chủ - Quản lý kết quả học tập'>
             <div className={styles.container}>
                {/* Hàng đầu tiên */}
                <div className={styles.row}>
                    {/* Chart chính - Sinh viên tốt nghiệp */}
                
                        <div className={styles.colLarge}>
                            <TotalRevenueChart />
                        </div>
                        
                        {/* Sidebar phải */}
                        <div className={styles.colSmall}>
                            <div className={styles.sidebarContent}>
                                <StatCards />
                                <StudentStatusChart />
                            </div>
                        </div>  
                    
                </div>

                {/* Hàng thứ hai */}
                <div className={styles.row}>
                    <div className={styles.colMedium}>
                        <GraduationByLevel />
                    </div>
                    <div className={styles.colMedium}>
                        <GradeRankingChart />
                    </div>
                    <div className={styles.colMedium}>
                        <StudentsByLevel />
                    </div>
                </div>
            </div>

        </Page>
    );
};

export default HomePage;